import { As, Box, Flex, useBreakpointValue, Text } from '@chakra-ui/react';
import ArticleGridWrapper from './ArticleGridWrapper';
import { QuoteIcon } from '../icons';
import { ServiceTestimonialsProps } from '../types';
import Carousel from './Carousel/Carousel';
import { SectionHeader } from './BasicBlocks';

interface TestimonialProps {
  content: string;
  name: string;
  date: string;
  as: As;
}

const Testimonial = ({ content, name, date, as = 'div' }: TestimonialProps) => (
  <Flex borderRadius="lg" bg="gray1" p={5} mb="auto" as={as}>
    <Box color="greenSpruce" mr={3}>
      <QuoteIcon />
    </Box>
    <Box>
      <Text textStyle="lg" mb="3">
        {content}
      </Text>
      <Text textStyle="sm">
        <Text as="span" mr="3" fontWeight="500">
          {name}
        </Text>
        <Text as="span" color="gray5">
          {date}
        </Text>
      </Text>
    </Box>
  </Flex>
);

const Testimonials = ({ title, testimonials }: ServiceTestimonialsProps) => {
  const isMobile = useBreakpointValue({ md: true });
  const isTablet = useBreakpointValue({ lg: true });

  if (!testimonials || testimonials.length < 1) {
    return null;
  }

  return (
    <Box
      gridColumn={['1 / -1', '1 / -1', '2']}
      as="section"
      data-test-id="testimonials"
    >
      <SectionHeader title={title} pl={[5, null, 0]} />
      {testimonials.length < 5 || !isMobile ? (
        <ArticleGridWrapper colCount={isTablet ? 3 : 4}>
          {testimonials?.map(({ id, content, name, date }) => (
            <Testimonial
              key={id}
              content={content}
              name={name}
              date={date}
              as="li"
            />
          ))}
        </ArticleGridWrapper>
      ) : (
        <Carousel carouselType={isTablet ? 'event' : 'teaser'}>
          {testimonials.map(({ id, content, name, date }) => (
            <Testimonial
              key={id}
              content={content}
              name={name}
              date={date}
              as="div"
            />
          ))}
        </Carousel>
      )}
    </Box>
  );
};
export default Testimonials;
